import * as _ from 'underscore'

import { OpFile } from '../core'
import { OpMessage } from './op-message'


export class OpEmail {
    //Properties
    public message: OpMessage
    public subject: string
    public cultureName: string
    public emailAddresses: string[]
    public emailAddressesCC: string[]
    public emailAddressesBCC: string[]
    public attachments: OpFile[]
    //Properties end    

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.message = new OpMessage(opObj.Message)
            this.subject = opObj.Subject
            this.cultureName = opObj.CultureName
            this.emailAddresses = opObj.EmailAddresses
            this.emailAddressesCC = opObj.EmailAddressesCC
            this.emailAddressesBCC = opObj.EmailAddressesBCC

            if (_.size(opObj.Attachments) > 0) {
                this.attachments = _.map(opObj.Attachments, (attachment: any) => new OpFile(attachment))
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            Message: this.message != null ? this.message.toJSON() : null,
            Subject: this.subject,
            CultureName: this.cultureName,
            EmailAddresses: this.emailAddresses,
            EmailAddressesCC: this.emailAddressesCC,
            EmailAddressesBCC: this.emailAddressesBCC,
            Attachments: this.attachments != null ? this.attachments.map((file: OpFile) => file.toJSON()) : null
        }
    }

    //#endregion
}